export const SET_TEAM_SETTING_OVERRIDE_UI_FLAG =
  'SET_TEAM_SETTING_OVERRIDE_UI_FLAG';
export const SET_TEAM_SETTING_OVERRIDE = 'SET_TEAM_SETTING_OVERRIDE';
export const DELETE_TEAM_SETTING_OVERRIDE = 'DELETE_TEAM_SETTING_OVERRIDE';
